import { useId, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router'
import { LogoRail } from '@carouselgg/nexus/logo-rail'
import { Popover } from '@carouselgg/nexus/popover'
import { Building2, Compass, Plus, Trophy } from '@carouselgg/nexus/icon'
import { useAuthStore } from '@carouselgg/auth/store'
import { useMyOrgs } from '@carouselgg/auth/use-my-orgs'
import { useMyTeams } from '@carouselgg/auth/use-my-teams'
import { railGroups } from './railItems'
import styles from './AppLogoRail.module.css'

/** + : the ways to get a new logo into the rail. */
function AddMenu({ signedIn }: { signedIn: boolean }) {
  const [open, setOpen] = useState(false)
  const anchor = useRef<HTMLButtonElement>(null)
  const id = useId()
  const close = () => setOpen(false)
  return (
    <>
      <button
        ref={anchor}
        type="button"
        className={styles.add}
        aria-label="Find or create a team or organization"
        aria-expanded={open}
        aria-haspopup="dialog"
        aria-controls={open ? id : undefined}
        onClick={() => setOpen((o) => !o)}
      >
        <Plus size={18} aria-hidden="true" />
      </button>
      <Popover id={id} open={open} onClose={close} anchorRef={anchor} label="Add a team or organization" className={styles.menu}>
        <Link to="/orgs" className={styles.menuItem} onClick={close}><Building2 size={16} aria-hidden="true" />Browse organizations</Link>
        <Link to="/compete" className={styles.menuItem} onClick={close}><Trophy size={16} aria-hidden="true" />Find a competition</Link>
        {signedIn && (
          <>
            <span className={styles.menuDivider} aria-hidden="true" />
            <Link to="/create-org" className={styles.menuItem} onClick={close}><Plus size={16} aria-hidden="true" />Create an organization</Link>
          </>
        )}
      </Popover>
    </>
  )
}

/**
 * The strip of your teams and orgs to the left of the side nav. Desktop only,
 * and only while the nav is open — collapsed, the logos fold into the nav's
 * own rail; on a phone they sit in the drawer.
 */
export function AppLogoRail({ className }: { className?: string }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const teams = useMyTeams(isAuthenticated)
  const orgs = useMyOrgs(isAuthenticated)
  const { pathname } = useLocation()
  const groups = railGroups(teams, orgs, pathname)
  const empty = groups.every((g) => g.length === 0)
  return (
    <LogoRail
      className={className ? `${styles.rail} ${className}` : styles.rail}
      groups={groups}
      footer={
        <>
          <AddMenu signedIn={isAuthenticated} />
          {empty && (
            <Link to="/orgs" className={styles.add} aria-label="Browse organizations">
              <Compass size={18} aria-hidden="true" />
            </Link>
          )}
        </>
      }
    />
  )
}
